// same gross approach as http://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/1203361#1203361
export default function getFileBasename(fname) {
  return fname.substr(fname.lastIndexOf("/")+1).split('?')[0].split('#')[0]
}
